/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mask{position:absolute;width:100%;height:100%;z-index:99999;background-color:#fff;top:0}.mask .spinner-wrap{line-height:100px;position:absolute;left:47%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.mask .spinner-wrap .spinner{position:absolute;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/page.spinner/page.spinner.component.scss.ngstyle.js.pre-build-optimizer.js